/* AURELIA theme.js — cart drawer, predictive search, variants, sticky ATC */
(function(){
  "use strict";
  var R = window.BLUECART || {};
  var money = function(c){
    try{
      var v=(c/100);
      return (R.moneyFormat||"AED {{amount}}").replace(/\{\{\s*\w+\s*\}\}/, v.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}));
    }catch(e){return c;}
  };
  function qs(s,el){return (el||document).querySelector(s);}
  function qsa(s,el){return Array.prototype.slice.call((el||document).querySelectorAll(s));}

  /* ---------- Cart Drawer ---------- */
  var drawer = qs('#CartDrawer');
  function openDrawer(){ if(!drawer)return; drawer.classList.add('is-open'); document.body.classList.add('no-scroll'); }
  function closeDrawer(){ if(!drawer)return; drawer.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
  function refreshDrawer(){
    if(!drawer)return;
    fetch(R.routes.cart_url + '?section_id=cart-drawer')
      .then(function(r){return r.text();})
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var fresh=qs('#CartDrawer .drawer__panel',doc);
        var cur=qs('#CartDrawer .drawer__panel');
        if(fresh&&cur)cur.innerHTML=fresh.innerHTML;
        bindDrawer();
      });
  }
  function updateCount(){
    fetch(R.routes.cart_url+'.js').then(function(r){return r.json();}).then(function(c){
      qsa('.cart-count').forEach(function(n){ n.textContent=c.item_count; n.hidden=c.item_count===0; });
    });
  }
  function addToCart(form){
    var btn=qs('[type=submit]',form);
    if(btn){btn.dataset.t=btn.textContent;btn.textContent=R.strings.adding||'Adding…';btn.disabled=true;}
    fetch(R.routes.cart_add_url+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(serialize(form))})
      .then(function(r){return r.json();})
      .then(function(){ updateCount(); refreshDrawer(); openDrawer(); })
      .catch(function(){})
      .finally(function(){ if(btn){btn.textContent=btn.dataset.t;btn.disabled=false;} });
  }
  function serialize(form){
    var id=qs('[name=id]',form); var qty=qs('[name=quantity]',form);
    return {id:id&&id.value, quantity:qty?parseInt(qty.value,10):1};
  }
  function changeLine(key,qty){
    fetch(R.routes.cart_change_url+'.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(){ updateCount(); refreshDrawer(); });
  }
  function bindDrawer(){
    qsa('[data-cart-close]').forEach(function(b){b.onclick=closeDrawer;});
    var scrim=qs('#CartDrawer .drawer__scrim'); if(scrim)scrim.onclick=closeDrawer;
    qsa('#CartDrawer [data-line-key]').forEach(function(row){
      var key=row.getAttribute('data-line-key');
      var minus=qs('[data-qd]',row),plus=qs('[data-qu]',row),inp=qs('input',row),rm=qs('[data-remove]',row);
      if(minus)minus.onclick=function(){var v=Math.max(0,parseInt(inp.value,10)-1);changeLine(key,v);};
      if(plus)plus.onclick=function(){changeLine(key,parseInt(inp.value,10)+1);};
      if(inp)inp.onchange=function(){changeLine(key,parseInt(inp.value,10)||0);};
      if(rm)rm.onclick=function(e){e.preventDefault();changeLine(key,0);};
    });
  }
  document.addEventListener('click',function(e){
    var open=e.target.closest('[data-cart-open]');
    if(open){e.preventDefault();refreshDrawer();openDrawer();}
    var qa=e.target.closest('[data-quick-add]');
    if(qa){
      e.preventDefault();
      var id=qa.getAttribute('data-variant-id');var label=qa.innerHTML;
      qa.disabled=true;qa.textContent=R.strings.adding||'Adding…';
      fetch(R.routes.cart_add_url+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:1})})
        .then(function(r){return r.json();})
        .then(function(){updateCount();refreshDrawer();qa.classList.add('is-added');qa.textContent='\u2713 '+(R.strings.added||'Added');
          setTimeout(function(){qa.classList.remove('is-added');qa.innerHTML=label;qa.disabled=false;},1600);})
        .catch(function(){qa.innerHTML=label;qa.disabled=false;});
    }
  });
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(f.matches('[data-product-form]')){e.preventDefault();addToCart(f);}
  });
  bindDrawer();

  /* ---------- Mobile menu ---------- */
  var mmenu=qs('#MobileMenu');
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-menu-open]')){e.preventDefault();mmenu&&mmenu.classList.add('is-open');document.body.classList.add('no-scroll');}
    if(e.target.closest('[data-menu-close]')||(mmenu&&e.target===qs('.mmenu__scrim',mmenu))){mmenu&&mmenu.classList.remove('is-open');document.body.classList.remove('no-scroll');}
  });

  /* ---------- Predictive search (always-visible input) ---------- */
  var sInput=qs('[data-search-input]'),sPop=qs('#SearchPop'),sBox=sPop&&qs('.search-results',sPop),sT;
  function closeSearch(){ if(sPop)sPop.hidden=true; }
  if(sInput&&sPop&&sBox){
    sInput.addEventListener('input',function(){
      clearTimeout(sT);var q=sInput.value.trim();
      if(q.length<2){closeSearch();sBox.innerHTML='';return;}
      sT=setTimeout(function(){
        fetch(R.routes.predictive_search_url+'.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
          .then(function(r){return r.json();}).then(function(j){
            var items=(j.resources&&j.resources.results&&j.resources.results.products)||[];
            sPop.hidden=false;
            if(!items.length){sBox.innerHTML='<p class="note" style="padding:12px">'+(R.strings.no_results||'No results')+'</p>';return;}
            sBox.innerHTML=items.map(function(p){
              var img=p.featured_image&&p.featured_image.url?'<img src="'+p.featured_image.url+'&width=96" alt="">':'';
              var price=p.price!=null?'<span class="price__now" style="font-size:13px">'+money(p.price)+'</span>':'';
              return '<a href="'+p.url+'">'+img+'<span style="flex:1;min-width:0"><span style="display:block;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'+p.title+'</span>'+price+'</span></a>';
            }).join('');
          }).catch(function(){closeSearch();});
      },200);
    });
    sInput.addEventListener('focus',function(){ if(sInput.value.trim().length>=2 && sBox.innerHTML)sPop.hidden=false; });
    document.addEventListener('click',function(e){ if(!e.target.closest('.header__search'))closeSearch(); });
  }

  /* ---------- Variant selection (PDP) ---------- */
  qsa('[data-variants]').forEach(function(root){
    var data;try{data=JSON.parse(qs('[data-variant-json]',root).textContent);}catch(e){return;}
    var form=qs('[data-product-form]',root),idInput=form&&qs('[name=id]',form);
    var priceNow=qs('[data-price-now]',root),priceWas=qs('[data-price-was]',root),priceSave=qs('[data-price-save]',root);
    var atc=form&&qs('[type=submit]',form);
    function current(){
      var sel={};
      qsa('[data-opt]',root).forEach(function(g){
        var on=qs('input:checked',g);if(on)sel[g.getAttribute('data-opt')]=on.value;
      });
      return data.find(function(v){return v.options.every(function(o,i){return o===sel['option'+(i+1)];});});
    }
    function apply(){
      var v=current();if(!v)return;
      if(idInput)idInput.value=v.id;
      if(priceNow)priceNow.textContent=money(v.price);
      if(priceWas)priceWas.textContent=v.compare_at_price&&v.compare_at_price>v.price?money(v.compare_at_price):'';
      if(priceSave){priceSave.textContent=v.compare_at_price&&v.compare_at_price>v.price?('-'+Math.round((1-v.price/v.compare_at_price)*100)+'%'):'';}
      if(atc){atc.disabled=!v.available;atc.textContent=v.available?(R.strings.add||'Add to Cart'):(R.strings.sold||'Sold Out');}
      var stk=qs('[data-sticky-price]');if(stk)stk.textContent=money(v.price);
      updateInst(v.price);
    }
    qsa('[data-opt] input',root).forEach(function(i){i.addEventListener('change',function(){
      var lbl=i.closest('.opt__values');if(lbl)qsa('.opt__chip',lbl).forEach(function(c){c.classList.toggle('is-on',qs('input',c).checked);});
      apply();
    });});
    apply();
  });

  /* installments calc */
  function updateInst(price){
    qsa('[data-inst]').forEach(function(el){
      var n=parseInt(el.getAttribute('data-inst-count'),10)||4;
      var per=el.querySelector('[data-inst-amount]');
      if(per)per.textContent=money(Math.ceil(price/n));
    });
  }

  /* ---------- qty steppers (PDP/cart page) ---------- */
  qsa('[data-qty]').forEach(function(w){
    var inp=qs('input',w),d=qs('[data-qd]',w),u=qs('[data-qu]',w);
    if(d)d.onclick=function(){inp.value=Math.max(1,parseInt(inp.value,10)-1);};
    if(u)u.onclick=function(){inp.value=parseInt(inp.value,10)+1;};
  });

  /* ---------- gallery ---------- */
  qsa('[data-gallery]').forEach(function(g){
    var main=qs('[data-gallery-main] img',g);
    qsa('[data-thumb]',g).forEach(function(t){
      t.onclick=function(){
        if(main){main.src=t.getAttribute('data-full');}
        qsa('[data-thumb]',g).forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
      };
    });
  });

  /* ---------- Esc closes overlays ---------- */
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){closeDrawer();mmenu&&mmenu.classList.remove('is-open');if(sPop)sPop.hidden=true;document.body.classList.remove('no-scroll');}
  });
})();
